import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import TrueCostCalculator from '@/components/sections/TrueCostCalculator';
// The existing "what is compliance really costing you?" calculator, on its own page.
const CalculatorPage = () => (
  <div className="min-h-screen bg-white" data-testid="calculator-page">
    <Header />
    <main>
      <TrueCostCalculator />
    </main>
    <Footer />
  </div>
);
export default CalculatorPage;
